/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  FormGroup,
  Label,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import Select from "react-select";

// actions
import {
  resetInsights,
  resetError,
  getInsights,
  deleteInsight,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

const Insights = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataInsight,
    dataInsightDelete,
    loadingInsight,
    loadingInsightDelete,
    errorInsight,
    successInsight,
  } = useSelector((state) => state.Insights);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [insightId, setInsightId] = useState("");
  const [insightName, setInsightName] = useState("");

  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [companyId, setCompanyId] = useState(null);

  const [dataInsightDistinct, setDataInsightDistinct] = useState([]);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successInsight && dispatch(resetInsights()) && handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getInsights(1, qtdDefault, name, companyId, true));
  };

  const handleDelete = () => {
    dispatch(deleteInsight(insightId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setInsightIdName = (insights) => {
    setInsightId(insights.id);
    setInsightName(insights.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getInsights(value, qtdDefault, nameFilter, companyId, true));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataInsight?.paging) {
      if (page < dataInsight.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const optionsCompany = () => {
    let companies = [];
    companies.push({ key: 0, value: null, label: t("All Companies") });

    dataInsight?.form?.clients &&
      dataInsight.form.clients.map((company, key) =>
        companies.push({ key: key + 1, value: company.id, label: company.name })
      );

    return companies;
  };

  const setDistinctArray = () => {
    if (dataInsight?.insights?.length > 0) {
      const map = new Map();
      const result = [];
      dataInsight.insights.forEach((item) => {
        if (!map.has(item.id)) {
          map.set(item.id, true); // set any value to Map
          result.push(item);
        }
      });
      setDataInsightDistinct(result);
    } else {
      setDataInsightDistinct([]);
    }
  };

  useEffect(() => {
    dispatch(getInsights(1, qtdDefault, null, null, true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dataInsightDelete && dataInsightDelete.message) {
      showToast("success", t(dataInsightDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successInsight]);

  useEffect(() => {
    if (errorInsight && typeof errorInsight === "object") {
      errorInsight.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorInsight) {
        showToast("error", t(errorInsight));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorInsight]);

  useEffect(() => {
    if (dataInsight !== null) {
      setNotFound(false);
      setDistinctArray();
    } else {
      setNotFound(true);
    }
  }, [dataInsight]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/insights"
            title={t("Dashboard")}
            breadcrumbItem={t("Insights")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <Label className="control-label">
                            {t("Company")}
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            className="w-100 mb-3"
                            placeholder={t("Company") + "..."}
                            options={optionsCompany()}
                            isLoading={loadingInsight}
                            isSearchable
                            onChange={(e) => {
                              setCompanyId(e.value);
                            }}
                            noOptionsMessage={() =>
                              t("No matching records found")
                            }
                            value={optionsCompany().find(
                              (item) => item.value === companyId
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-Insight">
                          <Link to="/insight">
                            <Button
                              type="button"
                              color="success"
                              className="waves-effect waves-light w-100 mr-2"
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Insight")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Name")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("RegEx")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingInsight ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataInsightDistinct.length > 0 ? (
                            dataInsightDistinct.map((insights, key) => (
                              <tr key={key}>
                                <td>{insights.name}</td>
                                <td>{insights.description}</td>
                                <td>{insights.regex}</td>

                                <td>
                                  <span style={{ cursor: "pointer" }}>
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id={`deletetooltip${key}`}
                                      onClick={() => {
                                        toggleModal();
                                        setInsightIdName(insights);
                                      }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`deletetooltip${key}`}
                                    >
                                      {t("Delete")}
                                    </UncontrolledTooltip>
                                  </span>
                                  <Link
                                    to={`/insight/${insights.id}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id={`edittooltip${key}`}
                                      onClick={() => {
                                        toggleModal();
                                        setInsightIdName(insights);
                                      }}
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="auto"
                                      target={`edittooltip${key}`}
                                    >
                                      {t("Edit")}
                                    </UncontrolledTooltip>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingInsightDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete this insight")}
                          <strong> {insightName}</strong>?{" "}
                          <strong className="text-danger">
                            {t("THIS WILL DELETE INSIGHT IN ALL COMPANIES")}
                          </strong>{" "}
                          {t(
                            "if you want to delete the insight of  a single company click on edit and remove the company on select field"
                          )}
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingInsightDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (insightId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataInsight &&
                  dataInsight.paging &&
                  dataInsight.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataInsight &&
                        dataInsight.paging &&
                        dataInsight.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Insights);
